import { useEffect } from "react";

import { toggleItems } from "app/components/widget/widget-utilities/time-granularity";
import { SwitcherGranularityContainer } from "app/pages/website-analysis/components/SwitcherGranularityContainer";

import { isMetricSupportedForGranularity } from "../config/config";
import { useHighLevelMetricsContext } from "../context";

export const GranularitySwitcher = () => {
    const { timeGranularity, setTimeGranularity, isPeriodOverPeriod, selectedMetricId } = useHighLevelMetricsContext();

    // Auto-switch to supported granularity when metric changes
    useEffect(() => {
        if (!isMetricSupportedForGranularity(selectedMetricId, timeGranularity.value)) {
            setTimeGranularity(toggleItems.Monthly);
        }
    }, [selectedMetricId, timeGranularity.value, setTimeGranularity]);
    const isTimeGranularityDisabled = null;
    const baseItemList = Object.values(toggleItems).map((item) => {
        const isNotSupportedByMetric = !isMetricSupportedForGranularity(selectedMetricId, item.value);
        return {
            ...item,
            disabled: (isTimeGranularityDisabled ? isTimeGranularityDisabled(item) : false) || isNotSupportedByMetric,
        };
    });
    const PeriodOverPeriodItemList = Object.values(toggleItems).map((item) => {
        const isNotSupportedByMetric = !isMetricSupportedForGranularity(selectedMetricId, item.value);
        return {
            ...item,
            disabled:
                item.value !== toggleItems.Monthly.value ||
                (isTimeGranularityDisabled ? isTimeGranularityDisabled(item) : false) ||
                isNotSupportedByMetric,
        };
    });
    const itemList = isPeriodOverPeriod ? PeriodOverPeriodItemList : baseItemList;
    const selectedIndex = itemList.findIndex(({ title }) => title === timeGranularity.title);
    const onItemClick = (index) => setTimeGranularity(itemList[index]);
    if (isTimeGranularityDisabled?.(timeGranularity)) {
        const newTimeGranularity = itemList.find(({ disabled }) => !disabled);
        setTimeGranularity(newTimeGranularity);
    }
    return (
        <SwitcherGranularityContainer
            itemList={itemList}
            selectedIndex={selectedIndex}
            onItemClick={onItemClick}
            customClass={"CircleSwitcher"}
        />
    );
};
